import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styleProps", "children", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useStyles, extractStyleProps } from '@bubble-ui/hook-use-styles';
import { View } from '@bubble-ui/primitive-view';
export var Box = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _extractStyleProps = extractStyleProps(props),
    {
      styleProps,
      children,
      style
    } = _extractStyleProps,
    rest = _objectWithoutProperties(_extractStyleProps, _excluded);
  var styles = useStyles(styleProps);
  return /*#__PURE__*/React.createElement(View, _extends({
    onRef: ref,
    style: _objectSpread(_objectSpread({}, styles), style)
  }, rest), children);
});
Box.displayName = 'Box';
//# sourceMappingURL=Box.js.map